import { FilterSelect } from '@/shared/ui';
import {
  METRIC_OPTIONS,
  GROUP_BY_OPTIONS,
  DATE_RANGE_OPTIONS,
  STATUS_OPTIONS,
  TRANSPORT_GROUP_OPTIONS
} from '../config/filter-options';
import type { DashboardOptions } from '@/entities/dashboard';

interface DashboardFilterBarProps {
  options: DashboardOptions;
  onOptionChange: (key: keyof DashboardOptions, value: string) => void;
  variant?: 'storage' | 'transport' | 'service' | 'service-users';
}

export function DashboardFilterBar({ options, onOptionChange, variant = 'storage' }: DashboardFilterBarProps) {
  switch (variant) {
    case 'transport':
      return <TransportFilters options={options} onOptionChange={onOptionChange} />;
    case 'service':
    case 'service-users':
      return <ServiceUsersFilters options={options} onOptionChange={onOptionChange} />;
    default:
      return <StorageFilters options={options} onOptionChange={onOptionChange} />;
  }
}

interface FilterProps {
  options: DashboardOptions;
  onOptionChange: (key: keyof DashboardOptions, value: string) => void;
}

function StorageFilters({ options, onOptionChange }: FilterProps) {
  return (
    <div className="flex gap-4 mb-6 flex-wrap">
      <FilterSelect
        label="Metric"
        value={options.metric || 'W'}
        onChange={(value) => onOptionChange('metric', value)}
        options={METRIC_OPTIONS}
      />
      <FilterSelect
        label="Group by"
        value={options.group || 'D'}
        onChange={(value) => onOptionChange('group', value)}
        options={GROUP_BY_OPTIONS}
        width="lg"
      />
    </div>
  );
}

function TransportFilters({ options, onOptionChange }: FilterProps) {
  return (
    <div className="flex gap-4 mb-6 flex-wrap">
      <FilterSelect
        label="Metric"
        value={options.metric || 'W'}
        onChange={(value) => onOptionChange('metric', value)}
        options={METRIC_OPTIONS}
      />
      <FilterSelect
        label="Group by"
        value={options.group || 'D'}
        onChange={(value) => onOptionChange('group', value)}
        options={TRANSPORT_GROUP_OPTIONS}
        width="lg"
      />
      <FilterSelect
        label="Period"
        value={options.trdate || 'L6M'}
        onChange={(value) => onOptionChange('trdate', value)}
        options={DATE_RANGE_OPTIONS}
      />
      <FilterSelect
        label="Status"
        value={options.status || 'DI'}
        onChange={(value) => onOptionChange('status', value)}
        options={STATUS_OPTIONS}
      />
    </div>
  );
}

function ServiceUsersFilters({ options, onOptionChange }: FilterProps) {
  return (
    <div className="flex gap-4 mb-6 flex-wrap">
      <FilterSelect
        label="Metric"
        value={options.metric || 'W'}
        onChange={(value) => onOptionChange('metric', value)}
        options={METRIC_OPTIONS}
      />
      <FilterSelect
        label="Period"
        value={options.trdate || 'L6M'}
        onChange={(value) => onOptionChange('trdate', value)}
        options={DATE_RANGE_OPTIONS}
      />
    </div>
  );
}
